import { debug } from "scripts/common"
import { GTAG_ID } from "./GoogleTagManager"

const CONVERSION_ID = {
  ES: "y76fCJjSn8IBEPHSj44D",
  CAR_ES: "lkm6COzwpqIBEPHSj44D",
  MULTISTEP_ES: "dCxNCMLIh9UBEPHSj44D",
  PT: "LBjACImyj8IBELyst-EC",
  CAR_PT: "2Z-8CPTbuaMBELyst-EC",
  MULTISTEP_PT: "9eUuCOjTh9UBELyst-EC",
  IT: "iGTnCO2UjsIBELzh_cIC",
  CAR_IT: "cg1BCMiyqMIBELzh_cIC",
  MULTISTEP_IT: "91u6CMjmldUBELzh_cIC"
}

// eslint-disable-next-line import/prefer-default-export
export function sendLead(car, multistep) {
  if (process.env.DISABLE_PIXELS) return

  if (debug) return

  const { countryCode = "ES" } = window
  let tagId = CONVERSION_ID[countryCode]
  if (car) tagId = CONVERSION_ID[`CAR_${countryCode}`]
  if (multistep) tagId = CONVERSION_ID[`MULTISTEP_${countryCode}`]
  window.gtag("event", "conversion", {
    send_to: `${GTAG_ID[countryCode]}/${tagId}`
  })
}
